import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, Table, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FaPencilAlt, FaTimes, FaTrashAlt } from 'react-icons/fa';
import { FaFloppyDisk } from "react-icons/fa6";
import { BASE_URL } from '../../../constants';
import Autocomplete from "react-google-autocomplete";
import 'react-toggle/style.css';
import Toggle from 'react-toggle';
function EditProperty() {
	const navigate = useNavigate();
	const { id } = useParams();
	const [errMsg, setErrMsg] = useState(null);
	const [validationError, setValidationError] = useState('');
	const [name, setName] = useState('');
	const [location, setLocation] = useState('');
	const [address, setAddress] = useState('');
	const [addressLine2, setAddressLine2] = useState('');
	const [city, setCity] = useState('');
	const [state, setState] = useState('');
	const [zip, setZip] = useState('');
	const [country, setCountry] = useState('');
	const [latitude, setLatitude] = useState('');
	const [longitude, setLongitude] = useState('');
	const [notes, setNotes] = useState('');
	const [type, setType] = useState(null);
	const [templates, setTemplates] = useState([]);
	const [originalType, setOriginalType] = useState(null);
	const [coverImage, setCoverImage] = useState(null);

	const [bedroom, setBedroom] = useState('');
	const [bathroom, setBathroom] = useState('');

	const [isEdited, setIsEdited] = useState(false);
	const [showAreas, setShowAreas] = useState(false)
	const [areas, setAreas] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);
	const [editAreaIdx, setEditAreaIdx] = useState(null);
	const [editedSubtitle, setEditedSubtitle] = useState('');

	// new amenity
	const [modalOpen, setModalOpen] = useState(false);
	const [availableItems, setAvailableItems] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);
	const [title, setTitle] = useState('');
	const [searchQuery, setSearchQuery] = useState("");

	useEffect(() => {
		(async () => {
			await fetchData();
		})()
	}, [id]);

	useEffect(() => {
		(async () => {
			await fetchAllAreas();
		})()
	}, [type]);

	useEffect(() => {
		fetchAvailableItems();
	}, [searchQuery]);

	useEffect(() => {
		fetchTemplates()
	}, []);

	const fetchTemplates = () => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/template/list?page_no=${1}&per_page=${100}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setTemplates(data.result.data);
					} else {
						console.error("Error: Unable to fetch templates data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};

	const fetchData = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const propertyResponse = await axios.get(`${BASE_URL}/property/details/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			const property = propertyResponse.data.result;

			if (property.name !== null) {
				setName(property.name);
			}
			if (property.location !== null) {
				setLocation(property.location);
			}
			if (property.address !== null) {
				setAddress(property.address);
			}
			if (property.address_line_2 !== null) {
				setAddressLine2(property.address_line_2);
			}
			if (property.city !== null) {
				setCity(property.city);
			}
			if (property.state !== null) {
				setState(property.state);
			}
			if (property.latitude !== null) {
				setLatitude(property.latitude);
			}
			if (property.longitude !== null) {
				setLongitude(property.longitude);
			}
			if (property.zip !== null) {
				setZip(property.zip);
			}
			if (property.country !== null) {
				setCountry(property.country);
			}
			if (property.type !== null) {
				setType(property.type);
				setOriginalType(property.type);
			} else {
				setType('SINGLE_FAMILY')
			}


			const areasResponse = await axios.get(`${BASE_URL}/property/${id}/areas`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			const areasData = areasResponse.data.result;
			console.log('property-areas', areasData)

			setSelectedAreas([...areasData]);

			if (Array.isArray(areasData)) {
				const bedroomCount = [...areasData].reduce((count, area) => {
					if (area.is_custom === 1 && area.title.toLowerCase().includes("bedroom")) {
						if (area.title.toLowerCase().includes("half")) {
							return count + 0.5;
						}
						return count + 1;
					}
					return count;
				}, 0);
				const bathroomCount = [...areasData].reduce((count, area) => {
					if (area.is_custom === 1 && area.title.toLowerCase().includes("bathroom")) {
						if (area.title.toLowerCase().includes("half")) {
							return count + 0.5;
						}
						return count + 1;
					}
					return count;
				}, 0);
				setBedroom(bedroomCount);
				setBathroom(bathroomCount);
			}

		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const fetchAllAreas = async () => {

		if (!type) return;

		const token = localStorage.getItem('token');
		if (token) {
			const response = await axios.get(`${BASE_URL}/template/all-areas?type=${type}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});

			if (response.data) {
				const data = response.data;
				console.log('fetchAllAreas', data)
				if (data.status) {
					setAreas(data.result.areas);

					if (originalType && originalType !== type) {
						setSelectedAreas(prev => prev.filter(area => area.property_id));
					}
				} else {
					console.error("Error: Unable to fetch areas data.");
				}
			}

		} else {
			console.error("Error: Authorization token is missing.");
		}
	};

	const handleLocationSelect = (place) => {
		if (!place || !place.address_components) {
			console.error("Invalid place object:", place);
			return;
		}

		const addressComponents = place.address_components;

		let newCity = '';
		let newState = '';
		let newCountry = '';
		let newZip = '';
		let newLocation = '';

		addressComponents.forEach(component => {
			const types = component.types;
			if (types.includes('locality')) {
				newCity = component.long_name;
			} else if (types.includes('administrative_area_level_1')) {
				newState = component.long_name;
			} else if (types.includes('country')) {
				newCountry = component.long_name;
			} else if (types.includes('postal_code')) {
				newZip = component.long_name;
			}
			place.geometry.location.lat()
		});

		newLocation = place.formatted_address;

		setLocation(newLocation);
		setCity(newCity);
		setState(newState);
		setCountry(newCountry);
		setAddress(newLocation);
		setZip(newZip);
		setLatitude(place.geometry.location.lat());
		setLongitude(place.geometry.location.lng());
	};

	const handleAddArea = () => {
		if (!bedroom || !bathroom) {
			setValidationError('Please enter the number of bedrooms and bathrooms.');
			return;
		}

		setValidationError('');

		const newAreas = [];

		// Add Bedrooms
		for (let i = 1; i <= Math.floor(bedroom); i++) {
			const existingBedroom = selectedAreas.find(area => area.title === `Bedroom ${i}`);
			if (existingBedroom) {
				newAreas.push(existingBedroom); // Keep existing bedroom with area_id
			} else {
				newAreas.push({ title: `Bedroom ${i}`, is_common: 0, is_custom: 1, type: 'bedroom', area_id: null });
			}
		}
		const existingHalfBedroom = selectedAreas.find(area => area.title === `Bedroom (half)`);
		if (existingHalfBedroom) {
			newAreas.push(existingHalfBedroom); // Keep existing half bedroom with area_id
		}
		else if (bedroom % 1 !== 0) {
			newAreas.push({ title: `Bedroom (half)`, is_common: 0, is_custom: 1, type: 'bedroom', area_id: null });
		}

		// Add Bathrooms
		for (let i = 1; i <= Math.floor(bathroom); i++) {
			const existingBathroom = selectedAreas.find(area => area.title === `Bathroom ${i}`);
			if (existingBathroom) {
				newAreas.push(existingBathroom); // Keep existing bathroom with area_id
			} else {
				newAreas.push({ title: `Bathroom ${i}`, is_common: 0, is_custom: 1, type: 'bathroom', area_id: null });
			}
		}
		const existingHalfBathroom = selectedAreas.find(area => area.title === `Bathroom (half)`);
		if (existingHalfBathroom) {
			newAreas.push(existingHalfBathroom); // Keep existing half bedroom with area_id
		}
		else if (bathroom % 1 !== 0) {
			newAreas.push({ title: `Bathroom (half)`, is_common: 0, is_custom: 1, type: 'bathroom', area_id: null });
		}

		setSelectedAreas(prevAreas => {
			const filteredAreas = prevAreas.filter(area => !area.title.startsWith('Bedroom') && !area.title.startsWith('Bathroom'));
			const allAreas = [...filteredAreas, ...newAreas];
			const sortedAreas = allAreas.sort((a, b) => b.is_custom - a.is_custom);
			return sortedAreas;
		})

		setShowAreas(true);
	};

	const handleAddNewArea = () => {
		setModalOpen(true);
		fetchAvailableItems();
	};

	const fetchAvailableItems = async () => {
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const response = await axios.get(`${BASE_URL}/area/item/non-custom?q=${searchQuery}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			setAvailableItems(response.data.result);
		} catch (error) {
			console.error("Error fetching area items", error);
		}
	};

	// add new amenity
	const handleModalSubmit = () => {
		if (!title || title === '' || selectedItems.length === 0) {
			return;
		}
		const newArea = {
			title: title,
			item_ids: [...selectedItems],
			is_common: 0,
			is_custom: 0,
			type: 'CUSTOM',
		};

		// Add new area and update filteredAreas
		setSelectedAreas([...selectedAreas, newArea]);

		// Reset input fields
		setTitle('');
		setSelectedItems([]);

		setModalOpen(false);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const token = localStorage.getItem('token');
			if (!token) {
				throw new Error('Authorization token is missing.');
			}

			const finalAreas = selectedAreas.map(area => ({
				area_id: area.id || null,
				title: area.title,
				sub_title: area.sub_title || '',
				type: area.type,
				item_ids: area.item_ids,
			}));

			console.log({finalAreas})

			const formData = new FormData();
			formData.append('type', type);
			formData.append('name', name);
			formData.append('location', location);
			formData.append('address', address);
			formData.append('address_line_2', addressLine2);
			formData.append('city', city);
			formData.append('state', state);
			formData.append('zip', zip);
			formData.append('country', country);
			formData.append('latitude', latitude);
			formData.append('longitude', longitude);
			formData.append('notes', notes);
			if (coverImage) {
				formData.append('cover_image', coverImage);
			}
			finalAreas.forEach((area, index) => {
				formData.append(`areas[${index}][area_id]`, area.area_id);
				formData.append(`areas[${index}][sub_title]`, area.sub_title);
				formData.append(`areas[${index}][title]`, area.title);
				formData.append(`areas[${index}][type]`, area.type);
				if (Array.isArray(area.item_ids)) {
					area.item_ids.forEach((itemId, itemIndex) => {
						formData.append(`areas[${index}][item_id][${itemIndex}]`, itemId);
					});
				}
			});

			for (let [key, value] of formData.entries()) {
				console.log(`${key}: ${value}`);
			}

			const response = await axios.put(`${BASE_URL}/property/update/${id}`, formData, {
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'multipart/form-data',
				}
			});

			if (response.data.status) {
				setIsEdited(true);
			} else {
				setErrMsg(response.data.message);
			}
		} catch (error) {
			setErrMsg(error);
		}
	};

	if (isEdited) {
		navigate('/property');
	}

	console.log('selectedAreas', selectedAreas)

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}
			{validationError && <Alert color="danger">{validationError}</Alert>}

			<h3>Edit Property</h3>
			<Card>
				<CardBody>
					<Form onSubmit={handleSubmit}>
						{(showAreas === false) ? (
							<>
								<Row>
									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="name">Name</Label>
											<Input type="text" name="name" id="name" value={name} onChange={(e) => setName(e.target.value)} />
										</FormGroup>
									</Col>
									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="type">Type</Label>
											<Input type="select" name="type" id="type" value={type} onChange={(e) => setType(e.target.value)}>
												{templates.map(template => {
													return (
														<option key={template.id} value={template.type}>{template.title}</option>
													)
												})}
											</Input>
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>

											<Label for="location">Location</Label>

											<Autocomplete
												apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
												onPlaceSelected={handleLocationSelect}
												/* Without this, location is only ever set by picking a Google
												   suggestion. If Places is unavailable, or the user types a full
												   address without selecting one, the field submits empty and the
												   API rejects it with "Location is required". */
										onChange={(e) => setLocation(e.target.value)}
												options={{
													types: ["geocode", "establishment"],
												}}
												style={{
													width: '100%',
													height: '40px',
													padding: '0.375rem 0.75rem',
													fontSize: '1rem',
													fontWeight: 400,
													lineHeight: 1.5,
													color: '#495057',
													backgroundColor: '#fff',
													backgroundClip: 'padding-box',
													border: '1px solid #ced4da',
													borderRadius: '0.25rem',
													transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
												}}
												defaultValue={location}
											/>


										</FormGroup>
									</Col>

									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="zip">Zip</Label>
											<Input type="text" name="zip" id="zip" value={zip} onChange={(e) => setZip(e.target.value)} />
										</FormGroup>
									</Col>
								</Row>
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="address">Address</Label>
									<Input type="text" name="address" id="address" value={address} onChange={(e) => setAddress(e.target.value)} />
								</FormGroup>
								<Row>
									<Col xs="4">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="city">City</Label>
											<Input type="text" name="city" id="city" value={city} onChange={(e) => setCity(e.target.value)} />
										</FormGroup>
									</Col>
									<Col xs="4">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="state">State</Label>
											<Input type="text" name="state" id="state" value={state} onChange={(e) => setState(e.target.value)} />
										</FormGroup>
									</Col>
									<Col xs="4">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="country">Country</Label>
											<Input type="text" name="country" id="country" value={country} onChange={(e) => setCountry(e.target.value)} />
										</FormGroup>
									</Col>
								</Row>
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="addressLine2">Address Line 2</Label>
									<Input type="text" name="addressLine2" id="addressLine2" value={addressLine2} onChange={(e) => setAddressLine2(e.target.value)} />
								</FormGroup>
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="notes">Notes</Label>
									<Input type="textarea" name="notes" id="notes" value={notes} onChange={(e) => setNotes(e.target.value)} />
								</FormGroup>
								<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
									<Label for="coverImage">Cover Image</Label>
									<Input type="file" name="coverImage" id="coverImage" onChange={(e) => setCoverImage(e.target.files[0])} />
								</FormGroup>

								<h4>Amenities</h4>

								<Row>
									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="bedroom">Number of Bedroom </Label>
											<Input type="number" name="bedroom" id="bedroom" min={0} max={6} value={bedroom} onChange={(e) => setBedroom(e.target.value)} />
										</FormGroup>
									</Col>
									<Col xs="6">
										<FormGroup style={{ paddingLeft: '10px', paddingRight: '10px' }}>
											<Label for="bathroom">Number of Bathroom</Label>
											<Input type="number" name="bathroom" id="bathroom" min={0} max={6} value={bathroom} onChange={(e) => setBathroom(e.target.value)} />
										</FormGroup>
									</Col>
								</Row>

								<Row className='mt-4 p-2'>
									{areas.filter(area => !area.title.startsWith('Bedroom') && !area.title.startsWith('Bathroom')).map((area, index) => {
										const isSelected = selectedAreas.find(s => s.id === area.id) ? true : false;

										return (
											<Col xs="6" md="4" key={area.id}>
												<Card className='bg-light'>
													<CardBody>
														<label className='d-flex justify-content-between align-items-center'>
															<span style={{ fontWeight: 'bold' }} >{area.title}</span>
															<Toggle
																checked={isSelected} // Toggle switch
																onChange={() => {
																	if (isSelected) {
																		setSelectedAreas(selectedAreas.filter(selectedArea => selectedArea.id !== area.id));
																	} else {
																		setSelectedAreas([...selectedAreas, area]);
																	}
																}}
															/>
														</label>
													</CardBody>
												</Card>
											</Col>
										)
									})}
								</Row>

								<Button color="secondary" onClick={() => navigate('/property')}>Cancel</Button>{' '}
								<Button style={{ marginLeft: '10px' }} color="primary" onClick={() => handleAddArea()}>Next</Button>
							</>
						) : (
							<>
								<Button color="primary" onClick={handleAddNewArea}>Add Amenity</Button>

								<Row className='p-2'>
									<Col xs="6" >
										{selectedAreas.map((area, index) => (
											<Card className='bg-light' key={`list-${area.id}`}>
												<CardBody >
													<div className='d-flex justify-content-between align-items-center'>
														<div>
															<p className='mb-1'><strong>{area.title}</strong></p>
															{(editAreaIdx === index) ? (
																<Input
																	type="text"
																	placeholder="Subtitle (Optional)"
																	value={editedSubtitle}
																	onChange={(e) => {
																		setEditedSubtitle(e.target.value)
																	}}
																	style={{ border: 'none', backgroundColor: '#EEEEEE' }}
																	size="sm"
																/>
															) : (
																<>
																	<p className='small text-muted m-0'>{area.sub_title}</p>
																</>

															)}
														</div>
														<div>
															{(editAreaIdx === index) ? (
																<FaFloppyDisk
																	style={{ cursor: 'pointer', fontSize: '20px' }}
																	onClick={() => {
																		setSelectedAreas([...selectedAreas.map((s, i) => {
																			if (editAreaIdx === i) {
																				return { ...s, sub_title: editedSubtitle }
																			}
																			return s;
																		})]);
																		setEditAreaIdx(null);
																	}} 
																/>
															) : (
																<>
																<FaPencilAlt
																	style={{ cursor: 'pointer', fontSize: '15px' }}
																	onClick={() => {
																		setEditAreaIdx(index);
																		setEditedSubtitle(area.sub_title || '');
																	}}
																/>
																<FaTrashAlt
																	style={{ cursor: 'pointer', fontSize: '15px', marginLeft: 15, color: '#F44336' }}
																	onClick={() => {
																		if (window.confirm('Are you sure you want to delete this area?')) {
																			setSelectedAreas(selectedAreas.filter((s, i) => i !== index));
																		}
																	}}
																/>
																</>
															)}
														</div>
													</div>
												</CardBody>
											</Card>
										))}
									</Col>
								</Row>

								<Button color="secondary" onClick={() => setShowAreas(false)}>Back</Button>

								<Button style={{ marginLeft: '10px' }} color="primary" type="submit">Submit</Button>
							</>
						)}
					</Form>
				</CardBody>
			</Card>

			<Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered size="md">
				<ModalHeader toggle={() => setModalOpen(!modalOpen)} style={{ display: 'flex', justifyContent: 'space-between' }} close={
					<button className="close" onClick={() => setModalOpen(!modalOpen)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
						<FaTimes size={20} />
					</button>
				}>Add New Amenity</ModalHeader>
				<ModalBody>
					<FormGroup>
						<Input
							type="text"
							placeholder="Title"
							value={title}
							onChange={(e) => setTitle(e.target.value)}
						/>
					</FormGroup>

					<div className="mt-3">
						<h6>Available Amenity Items:</h6>

						<Row className="my-3">
							<Col xs="12" className="text-end">
								<Input
									type="text"
									placeholder="Search by name"
									value={searchQuery}
									onChange={e => setSearchQuery(e.target.value)}
									style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
								/>
								{/* <Button color="primary" onClick={handleSearch}>Search</Button> */}
							</Col>
						</Row>

					</div>
					<div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '20px' }}>
						{availableItems && availableItems.length > 0 ? (
							availableItems.map((item) => (
								<div key={item.id} style={{ width: '50%', display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
									<Toggle
										checked={selectedItems.includes(item.id)}
										onChange={() => {
											if (selectedItems.includes(item.id)) {
												setSelectedItems(selectedItems.filter(selectedItem => selectedItem !== item.id));
											} else {
												setSelectedItems([...selectedItems, item.id]);
											}
										}}
										icons={false}
									/>
									<span style={{ marginLeft: '10px' }}>{item.name}</span>
								</div>
							))
						) : (
							<div style={{ textAlign: 'center', marginLeft: '10px', color: 'gray' }}>
								Amenity not found
							</div>
						)}

					</div>

				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={() => setModalOpen(false)}>Cancel</Button>
					<Button color="primary" onClick={handleModalSubmit}>Add Amenity</Button>
				</ModalFooter>
			</Modal>
		</div>
	)
}

export default EditProperty;